import no_data from "assets/morning/icon/notice.svg";

interface SearchStatusProps {
    type: "loading" | "empty";
}

export default function SearchStatus({ type }: SearchStatusProps) {
    const text = {
        loading: "목록을 불러오는 중입니다...",
        empty: "검색 결과가 없습니다.",
    };

    return (
        <div className="w-full flex flex-col items-center justify-center gap-[24px]">
            <img src={no_data} alt="아이콘" />
            <p className="text-[22px] text-[#878A93] font-[500]">{text[type]}</p>
        </div>
    );
}
